import { AdditionalServicesModule } from '@additional-services/additional.services.module';
import { ProductDetailsModule } from '@product-details/product.details.module';
import { CompareModule } from '@compare/compare.module';
import { SharedModule } from '@shared/shared.module';
import { ViewOffersModule } from '@view-offers/view-offers.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CompleteOrderModule } from '@complete-order/complete-order.module';
import { ConfirmationModule } from '@confirmation/confirmation.module';

import * as fromComponents from './components';
import * as fromContainers from './containers';
import { DgxQmModule } from '@domgen/dgx-fe-qm';
import { DgxComponentsButtonModule } from '@domgen/dgx-fe-components/button';
import { DgxComponentsAccordionModule } from '@domgen/dgx-fe-components/accordion';
import { DgxComponentsPanelModule } from '@domgen/dgx-fe-components/panel';
import { DgxComponentsIconModule } from '@domgen/dgx-fe-components/icon';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [...fromContainers.containers, ...fromComponents.components],
  imports: [
    CommonModule,
    CompareModule,
    ViewOffersModule,
    SharedModule,
    ProductDetailsModule,
    AdditionalServicesModule,
    CompleteOrderModule,
    ConfirmationModule,
    DgxQmModule.forRoot(),
    DgxComponentsButtonModule,
    DgxComponentsAccordionModule,
    DgxComponentsPanelModule,
    DgxComponentsIconModule,
    RouterModule,
  ],
  exports: [...fromContainers.containers, ...fromComponents.components],
})
export class PagesModule {}
